<template>
  <!--传球分布 散点图表-->
  <div class="expect_goal">
    <div class="expectGoal_box" @click.stop="downLoad">
      <div
        :class="
          echartData.objectInfos.length === 2 ? 'expectGoal2' : 'expectGoal1'
        "
        ref="expectGoal"
      ></div>
    </div>
    <!-- <div
      class="expectGoal_left"
      v-if="location== `#/${$storage.getLocal('mixtmt_userInfo').stationName}/homeGame/creation`"
    >
      <p v-for="(item,index) of echartData.basisStatisticsModel.dimensionNames" :key="index">
        {{item}}
        <span>{{echartData.basisStatisticsModel.resultData[0][index]}}</span>
      </p>
      <div class="expectGoal_left_cicle"></div>
    </div>
    <div class="expectGoal_box" @click.stop="downLoad">
      <div
        :class="echartData.objectInfos.length === 2?'expectGoal2':'expectGoal1'"
        ref="expectGoal"
      ></div>
    </div>
    <div
      class="expectGoal_right"
      v-if="location== `#/${$storage.getLocal('mixtmt_userInfo').stationName}/homeGame/creation`"
    >
      <div v-if="echartData.basisStatisticsModel.resultData[1]" class="expectGoal_right_top">
        <p v-for="(item,index) of echartData.basisStatisticsModel.dimensionNames" :key="index">
          <span>{{echartData.basisStatisticsModel.resultData[1][index]}}</span>
          {{item}}
        </p>
      </div>

      <div class="expectGoal_right_cicle">
        <p>
          <i class="cicle1"></i>
          <span>进球</span>
        </p>
        <p>
          <i class="cicle2"></i>
          <span>射正</span>
        </p>
        <p>
          <i class="cicle3"></i>
          <span>射偏</span>
        </p>
      </div>
    </div> -->
  </div>
</template>

<script>
// 原点位于左上
// import storage from "../../uitls/storage";
import { SCATTER_COURTPLANE } from './mockData.json'
export default {
  props: {
    // echartData: {
    //   default: function() {
    //     return {
    //       objectInfos: [],
    //       basisStatisticsModel: {}
    //     };
    //   }
    // },
    width: {
      // default: '100%',
    },
    height: {
      // default: '100%',
    },
    isDownLoadImg: {
      // 是否可以下载图片
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      location: '',
      lt: {
        // 原点
        name: 'lt',
        x: 0,
        y: 0,
        symbolSize: 0, //大小
      },
      rb: {
        // 边界

        symbolSize: 20,
      },
      linesData: [], // 散点位置
      splashesSize: 0.08, // 散点大小，依据宽度进行计算
      positive: '#CC8FD9', //射正
      deflection: '#098CCB', //射偏
      score: '#D0021B', //射进
      lineWidth: 20, // 线条粗细
      lineType: 'solid', // 线条样式 "solid" "dashed" "dotted"
      lineCurveness: 0, // 设置线条曲线 0-1
      lineOpacity: 1, // 透明度 0-1
      isDb: true, // 双击禁止
      echartData: null,
    }
  },
  watch: {
    echartData: {
      handler: function () {
        this.countLinesData()
        this.initChart()
      },
      deep: true,
    },
  },
  created() {
    this.echartData = SCATTER_COURTPLANE
    this.location = location.hash
  },
  mounted() {
    this.$nextTick(() => {
      const smallDom = this.$refs.expectGoal
      this.pWidth = smallDom.clientWidth
      this.pHeight = smallDom.clientHeight
      this.countLinesData()
      this.initChart()
    })
  },
  methods: {
    initChart() {
      const _this = this
      const myPassesChart = this.$echarts.init(this.$refs.expectGoal)
      let options = {
        series: [
          {
            type: 'graph',
            layout: 'none',
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            symbolSize: 10,
            label: {
              normal: {
                show: true,
              },
            },
            edgeSymbol: ['circle', 'arrow'],
            edgeLabel: {
              normal: {
                textStyle: {
                  fontSize: 10,
                },
              },
            },
            data: this.linesData,
          },
        ],
      }
      myPassesChart.setOption(options)
    },
    countLinesData() {
      let linesDataHold = []
      linesDataHold.push(this.lt) // 固定原点eventData
      this.echartData.eventData.forEach((item, index) => {
        linesDataHold.push({
          x: this.pWidth * (item.x / 100),
          y: this.pHeight * ((100 - item.y) / 100),
          symbolSize:
            this.pWidth *
            item.r *
            (item.r >= 0.1 ? (item.r >= 0.4 ? 0.05 : 0.09) : 0.28),
          itemStyle: {
            color:
              item.type == 1
                ? this.positive
                : item.type == 2
                ? this.deflection
                : this.score,
          },
        })
      })
      linesDataHold.push({
        // 设置当前边界值
        name: 'rb',
        x: this.pWidth,
        y: this.pHeight,
        symbolSize: 0,
      })
      this.linesData = linesDataHold
    },

    countLinks() {},
    downLoad() {
      if (!this.isDownLoadImg) {
        return
      }
      if (!this.isDb) {
        return
      }
      this.isDb = false
      this.$nextTick(() => {
        const passesRef = this.$refs.expectGoal
        const childCanvas = passesRef.children[0].children[0]
        this.toImage.getOptions({
          el: childCanvas,
        })
      })
      setTimeout(() => {
        this.isDb = true
      }, 500)
    },
  },
}
</script>

<style scoped lang="scss">
.expect_goal {
  width: 100%;
  // height: 100%;
  height: 290px;
  display: flex;
  justify-content: space-between;
  // align-items: center;
  .expectGoal_left {
    width: 105px;
    height: 100%;
    display: flex;
    text-align: left;
    justify-content: space-between;
    flex-direction: column;
    padding-top: 4px;
    // padding: 7% 0;
    & > p {
      font-family: 'PingFangSC-Semibold';
      font-size: 12px;
      height: 30px;
      line-height: 30px;
      color: #151515;
      letter-spacing: 0;
      line-height: 100%;
      & > span {
        font-weight: 600;
      }
    }
    .expectGoal_left_cicle {
      height: 48px;
    }
  }
  .expectGoal_right {
    width: 105px;
    height: 100%;
    display: flex;
    text-align: right;
    justify-content: space-between;
    flex-direction: column;
    padding-top: 4px;
    // padding: 7% 0;
    .expectGoal_right_top {
      & > p {
        font-family: 'PingFangSC-Semibold';
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        color: #151515;
        letter-spacing: 0;
        line-height: 100%;
        & > span {
          font-weight: 600;
        }
      }
    }

    .expectGoal_right_cicle {
      display: flex;
      flex-direction: column;
      padding-left: 35px;
      & > p {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        align-items: center;
        & > i {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          display: inline-block;
        }
        .cicle1 {
          background: #d0021b;
        }
        .cicle2 {
          background: #098ccb;
        }
        .cicle3 {
          background: #cc8fd9;
        }
        span {
          font-family: 'MicrosoftYaHei';
          font-size: 12px;
          color: #b9b9b9;
          letter-spacing: 0;
          text-align: center;
        }
      }
    }
  }
  .expectGoal_box {
    flex: 1;
    // flex-shrink: 0;
    width: 100%;
    background: #eaedf1;
    border: 6px solid #eaedf1;
    border-radius: 10px;
    // height: 100%;
    .expectGoal1 {
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
      background-image: var(--mixtmt_ball_border_bg);
      background-repeat: no-repeat;
      background-position: center;

      transform: rotateZ(180deg);
    }
    .expectGoal2 {
      width: 100%;
      height: 100%;
      background-image: var(--mixtmt_ball_border_bg);
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
    }
  }
}
</style>
